import Profile from './Profile';

export default Profile
export { Profile as Base }